"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Cover = ({ cover }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("img", { src: cover, alt: "cover", style: {
            width: "100%",
            height: theme.spacing(20),
            objectFit: "cover",
            // borderRadius: 8,
        } }));
};
exports.Cover = Cover;
exports.Cover.displayName = "Cover";
